import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./Logo";
import { FadeUp } from "./Reveal";

export default function LegalPage({ title, subtitle, updated, sections, testid }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen px-6 md:px-12 py-10 md:py-14" data-testid={testid}>
      <div className="max-w-[920px] mx-auto">
        <Link
          to="/"
          data-testid={`${testid}-back-link`}
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#111111]/50 hover:text-[#16783F] transition-colors duration-300"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back to site
        </Link>

        <header className="mt-12 border-b border-[#111111]/10 pb-12">
          <div className="flex items-center gap-3">
            <Logo testid={`${testid}-logo`} className="h-10 w-10" />
            <span className="font-serif text-2xl tracking-tight">My Fresh Tracker</span>
          </div>
          <h1 className="font-serif font-light tracking-tight text-5xl md:text-7xl mt-10" data-testid={`${testid}-title`}>
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base md:text-lg text-[#111111]/70 max-w-xl leading-relaxed">{subtitle}</p>
          )}
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-[#111111]/50">
            Last updated: {updated}
          </p>
        </header>

        <div className="mt-16 space-y-16 pb-24">
          {sections.map((s, i) => (
            <FadeUp key={s.heading} delay={Math.min(i * 0.05, 0.25)}>
              <section data-testid={`${testid}-section-${i + 1}`}>
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-sm text-[#16783F]">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="font-serif text-3xl md:text-4xl tracking-tight">{s.heading}</h2>
                </div>
                <div
                  className={`mt-6 md:ml-12 ${
                    s.highlight
                      ? "bg-[#FFFFFF] border border-[#111111]/10 border-l-4 border-l-[#1F9D55] p-8 md:p-10 space-y-5"
                      : "space-y-4 max-w-2xl"
                  }`}
                >
                  {s.body.map((p, j) => (
                    <p
                      key={j}
                      className={`leading-relaxed ${
                        s.highlight
                          ? "text-base md:text-lg text-[#111111]/85"
                          : "text-base md:text-lg text-[#111111]/75"
                      }`}
                    >
                      {p}
                    </p>
                  ))}
                </div>
              </section>
            </FadeUp>
          ))}

          <div className="border-t border-[#111111]/10 pt-10 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <p className="text-sm text-[#111111]/60">
              Questions? Write to{" "}
              <a href="mailto:myfreshtracker@gmail.com" className="text-[#16783F] hover:underline">
                myfreshtracker@gmail.com
              </a>
            </p>
            <Link
              to="/"
              className="text-xs uppercase tracking-[0.2em] font-semibold text-[#111111]/60 hover:text-[#16783F] transition-colors duration-300"
            >
              myfreshtracker.com
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
